<template>
  <PublicPopup
    ref="LoginRegisterPopupRef"
    type="fullScreen"
    position="bottom"
    close-on-click-overlay
    :closeable="false"
    height="100vh"
    @close="handleCloseEmit"
  >
    <template #content>
      <div class="dragon-img-box" @click="handleCloseLoginRegisterPopup">
        <img class="dragon-img" :src="getImageUrlWithCDN_LOCAL('/login/dragon_img.png')" />
        <img
          class="dragon-img-shan"
          :class="{ 'animation-paused': !isDragonAnimationPlaying }"
          :src="getImageUrlWithCDN_LOCAL('/gold_coins/light.png')"
        />
      </div>
      <div class="login-reg-popup-container">
        <div class="header-container">
          <span class="title">{{ t('home-index.auth.rewardRegistration') }}</span>
          <br />
          <span class="subtitle">
            <i>{{ t('home-index.auth.bonusUpTo', { amount: `${t('CurrencySymbol')} 777` }) }}</i>
          </span>
        </div>

        <van-tabs v-model:active="activeName">
          <InterestTagLei v-if="isWin2" type-location="bottom"></InterestTagLei>
          <van-tab :title="t('home-index.auth.register')" name="register">
            <van-form validate-trigger="onChange" @submit="registerHandle" @failed="registerFailed">
              <van-field
                v-model="postDataReg.username"
                :clearable="true"
                name="username"
                :placeholder="t('home-index.auth.accountPlaceholder')"
                :rules="rulesReg.username"
                maxlength="14"
                type="text"
                @input="handleUsernameInput"
                @keydown="handleUsernameKeydown"
                @compositionstart="handleCompositionStart"
                @compositionend="handleCompositionEnd"
              >
                <template #left-icon>
                  <div v-if="isWin2" class="label-icon-box chxy-row-c-c">
                    <img :src="getImageUrlWithCDN_LOCAL('/form_pubilc/phone.svg')" class="icon" />
                  </div>
                  <img v-else :src="getImageUrlWithCDN_LOCAL('/form_pubilc/user.svg')" class="icon" />
                </template>
              </van-field>

              <van-field
                v-model="postDataReg.password"
                :clearable="true"
                :type="isPasswordVisible ? 'text' : 'password'"
                name="password"
                :placeholder="t('home-index.auth.setPasswordPlaceholder')"
                :rules="rulesReg.password"
                :maxlength="MAX_PWD"
              >
                <template #left-icon>
                  <img :src="getImageUrlWithCDN_LOCAL('/form_pubilc/lock.png')" class="icon" />
                </template>

                <template #right-icon>
                  <img
                    :src="getImageUrlWithCDN_LOCAL(`/form_pubilc/eye-${isPasswordVisible ? 'on' : 'off'}.png`)"
                    class="icon eye-icon"
                    :class="{ 'eye-icon--on': isPasswordVisible }"
                    @click="togglePasswordVisibility"
                  />
                </template>
              </van-field>

              <van-field
                v-show="!isPasswordVisible"
                v-model="postDataReg.password_confirm"
                :clearable="true"
                :type="isPasswordConfirVisible ? 'text' : 'password'"
                name="password_confirm"
                :placeholder="t('home-index.auth.confirmPasswordPlaceholder')"
                :rules="rulesReg.password_confirm"
                class="custom-label"
              >
                <template #left-icon>
                  <img :src="getImageUrlWithCDN_LOCAL('/form_pubilc/lock.png')" class="icon" />
                </template>
                <template #right-icon>
                  <img
                    :src="getImageUrlWithCDN_LOCAL(`/form_pubilc/eye-${isPasswordConfirVisible ? 'on' : 'off'}.png`)"
                    class="icon eye-icon"
                    :class="{ 'eye-icon--on': isPasswordConfirVisible }"
                    @click="togglePasswordConfirVisibility"
                  />
                </template>
              </van-field>

              <div class="checkbox-box">
                <van-checkbox v-model="checkedReg" class="checkbox">
                  <span class="value">{{ t('home-index.auth.rememberMe') }}</span>
                </van-checkbox>
              </div>

              <van-button :loading="loading" native-type="submit" class="__button_primary submit">Confirmar</van-button>
            </van-form>
          </van-tab>

          <van-tab :title="t('home-index.auth.login')" name="login">
            <van-form :model="postData" :rules="rules" validate-trigger="onSubmit" @submit="loginHandle">
              <van-field
                v-model="postData.username"
                :clearable="true"
                :rules="rules.username"
                name="username"
                :placeholder="t('home-index.auth.accountPlaceholder')"
                type="text"
                maxlength="14"
                :border="true"
                @input="handleLoginUsernameInput"
                @keydown="handleLoginUsernameKeydown"
                @compositionstart="handleLoginCompositionStart"
                @compositionend="handleLoginCompositionEnd"
              >
                <template #left-icon>
                  <div v-if="isWin2" class="label-icon-box chxy-row-c-c">
                    <img :src="getImageUrlWithCDN_LOCAL('/form_pubilc/phone.svg')" class="icon" />
                  </div>
                  <img v-else :src="getImageUrlWithCDN_LOCAL('/form_pubilc/user.svg')" class="icon" />
                </template>
              </van-field>

              <van-field
                v-model="postData.password"
                :clearable="true"
                :type="loginPasswordConfirVisible ? 'text' : 'password'"
                :rules="rules.password"
                name="password"
                :placeholder="t('home-index.auth.passwordPlaceholder')"
                :maxlength="MAX_PWD"
              >
                <template #left-icon>
                  <img :src="getImageUrlWithCDN_LOCAL('/form_pubilc/lock.png')" class="icon" />
                </template>

                <template #right-icon>
                  <img
                    :src="getImageUrlWithCDN_LOCAL(`/form_pubilc/eye-${loginPasswordConfirVisible ? 'on' : 'off'}.png`)"
                    class="icon eye-icon"
                    :class="{ 'eye-icon--on': loginPasswordConfirVisible }"
                    @click="loginPasswordFun"
                  />
                </template>
              </van-field>

              <div class="checkbox-box">
                <van-checkbox v-model="checkedLogin" class="checkbox">
                  <span class="value">{{ t('home-index.auth.rememberMe') }}</span>
                </van-checkbox>
              </div>

              <van-button :loading="loading" native-type="submit" class="__button_primary submit">
                {{ t('home-index.auth.submitLogin') }}
              </van-button>
            </van-form>
          </van-tab>
        </van-tabs>

        <div v-if="activeName == 'login'" class="footer-container chxy-row-c-c" @click="toCliente">
          <span>{{ t('home-index.auth.forgotPassword') }}</span>
        </div>
      </div>
    </template>
  </PublicPopup>

  <!-- 忘记密码弹窗 -->
  <ForgetPassword v-model:show="forgetPasswordVisible" @close="closeForgetPwd" />

  <!-- 错误信息弹窗 -->
  <ClosePopup ref="ErrorPopupRef">
    <template #header>
      <div class="error-header">
        <van-icon name="warning-o" color="#EA4E3D" size="20" />
        <span class="title">{{ t('home-index.auth.importantNotice') }}</span>
      </div>
    </template>
    <template #content>
      <div class="error-content">
        <div class="prompt">
          <span>{{ t('home-index.auth.invalidCredentials') }}</span>
        </div>
        <div class="button" @click="handleCloseErrorPopup">{{ t('home-index.common.confirm') }}</div>
      </div>
    </template>
  </ClosePopup>
</template>

<script setup>
import { REMEMBER_CREDENTIALS_KEY } from '@/stores/mutation-type' // 定义记住账号和密码的存储键名
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore, usePathsStore } from '@/stores'
import { useI18n } from 'vue-i18n'
import { useEventBus } from '@vueuse/core'
import vw from '@/utils/inline-px-to-vw'
import { showNotify } from 'vant'
import { v4 as uuidv4 } from 'uuid'
import { templateTypeWin2FlagWithLoginUserIcon } from '@/utils/templateType'

// 创建eventBus实例
const eventBus = useEventBus('refreshHomeInfo')

const { t } = useI18n()
const router = useRouter()
const userStore = useUserStore()
const pathsStore = usePathsStore()
const loading = ref(false)
const activeName = ref('register')
const checkedReg = ref(true)
const checkedLogin = ref(true)
const isPasswordVisible = ref(false) // 控制密码框是否可见
const isPasswordConfirVisible = ref(false) // 控制密码框是否可见
const loginPasswordConfirVisible = ref(false) // 控制登录密码框是否可见
const isDragonAnimationPlaying = ref(true) // 控制龙动画是否播放

const postDataReg = reactive({
  username: '',
  password: '',
  password_confirm: '',
  phone: '',
})

const isWin2 = ref(false)

/**
 * 密码相关常量
 */
const MIN_PWD = 6
const MIN_LOGIN_PWD = 1
const MAX_PWD = 16

// const appid = computed(() => {
//   // console.log('appid·', JSON.parse(localStorage.getItem('localConfig')).appid)
//   return JSON.parse(localStorage.getItem('localConfig')).appid
// })

const LoginRegisterPopupRef = ref(null)
const handleOpenLoginRegisterPopup = () => {
  nextTick(() => {
    LoginRegisterPopupRef.value.open()
    isDragonAnimationPlaying.value = true
  })
}
const handleCloseLoginRegisterPopup = () => {
  isDragonAnimationPlaying.value = false // 关闭时停止动画
  nextTick(() => {
    LoginRegisterPopupRef.value.close()
  })
  handleCloseEmit()
}

const handleCloseEmit = () => {
  emit('close')
}
const openPopupRegLogin = (type) => {
  activeName.value = type || 'register'
  handleOpenLoginRegisterPopup()
}

// 生成或获取设备唯一标识 (这是一个简单示例，您可能需要更稳定的方案)
const generateDeviceId = () => {
  let deviceId = ''
  if (localStorage.getItem('deviceId')) {
    deviceId = localStorage.getItem('deviceId')
  } else {
    deviceId = uuidv4().replace(/-/g, '')
    localStorage.setItem('deviceId', uuidv4().replace(/-/g, ''))
  }
  return deviceId
}

// 使用现代API获取设备信息 (替代已弃用的属性)[6](@ref)
const getDeviceInfo = async () => {
  const deviceInfo = {
    device_id: generateDeviceId(),
  }
  // 1. 尝试使用新的 userAgentData API (现代浏览器)
  if (navigator.userAgentData) {
    try {
      const highEntropyData = await navigator.userAgentData.getHighEntropyValues([
        'platform',
        'platformVersion',
        'model',
        'fullVersionList',
      ])
      deviceInfo.os_name = highEntropyData.platform
      deviceInfo.os_version = highEntropyData.platformVersion
      deviceInfo.device_model = highEntropyData.model

      // 从 fullVersionList 中获取浏览器信息
      const chromeBrand = highEntropyData.fullVersionList.find((item) => item.brand === 'Chromium')
      if (chromeBrand) {
        deviceInfo.brower_type = `${chromeBrand.brand} v${chromeBrand.version}`
      }
    } catch (error) {
      console.warn('获取高熵值 User-Agent 数据失败:', error)
    }
  }

  // 2. 降级方案：分析 User-Agent 字符串 (兼容旧浏览器)
  const ua = navigator.userAgent
  if (!deviceInfo.brower_type) {
    if (ua.includes('Chrome')) deviceInfo.brower_type = 'Chrome' + (ua.match(/Chrome\/([\d.]+)/)?.[1] || '')
    else if (ua.includes('Firefox')) deviceInfo.brower_type = 'Firefox' + (ua.match(/Firefox\/([\d.]+)/)?.[1] || '')
    else if (ua.includes('Safari')) deviceInfo.brower_type = 'Safari' + (ua.match(/Version\/([\d.]+)/)?.[1] || '')
  }

  if (!deviceInfo.os_name) {
    if (ua.includes('Windows')) deviceInfo.os_name = 'Windows'
    else if (ua.includes('Mac')) deviceInfo.os_name = 'macOS'
    else if (ua.includes('Linux')) deviceInfo.os_name = 'Linux'
    else if (ua.includes('Android')) deviceInfo.os_name = 'Android'
    else if (ua.includes('iOS') || ua.includes('iPad') || ua.includes('iPhone')) deviceInfo.os_name = 'iOS'
  }

  // 3. 补充其他信息
  deviceInfo.client_name = 'H5' // 可根据实际情况修改，例如从项目配置中读取版本号

  // 设备品牌信息通常需要特定API或UA分析，这里简单示例
  if (ua.includes('Android')) deviceInfo.device_brand = ua.match(/(?<=; )(.*?)(?= Build)/)?.[0] || 'Android Device'
  if (/(iPhone|iPad|iPod)/.test(ua)) deviceInfo.device_brand = 'Apple'

  return deviceInfo
}

const ErrorPopupRef = ref(null)
const handleOpenErrorPopup = () => {
  ErrorPopupRef.value.openPopupClose()
}
const handleCloseErrorPopup = () => {
  ErrorPopupRef.value.closePopup()
}

// 切换密码可见性
const togglePasswordVisibility = () => {
  isPasswordVisible.value = !isPasswordVisible.value
}

// 切换密码可见性
const togglePasswordConfirVisibility = () => {
  isPasswordConfirVisible.value = !isPasswordConfirVisible.value
}

// 切换密码可见性
const loginPasswordFun = () => {
  loginPasswordConfirVisible.value = !loginPasswordConfirVisible.value
}

const passwordStrength = ref(0) // 密码强度等级（0-3）

const calculatePasswordStrength = (password) => {
  let strength = 0

  // 规则1：长度 >= 6
  if (password.length >= 6) strength += 1

  // 规则2：包含数字
  if (/\d/.test(password)) strength += 1

  // 规则3：包含特殊字符
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) strength += 1

  // 规则4：长度 >= 10（新增规则）
  if (password.length >= 10) strength += 1

  // 限制强度最大值为4
  passwordStrength.value = Math.min(strength, 4)
}

watch(
  () => postDataReg.password,
  (newPassword) => {
    calculatePasswordStrength(newPassword.trim())
  }
)

const postData = reactive({
  username: '',
  password: '',
})

// 在组件挂载时检查是否有记住的账号和密码
onMounted(async () => {
  isWin2.value = await templateTypeWin2FlagWithLoginUserIcon()
  const rememberedCredentials = localStorage.getItem(REMEMBER_CREDENTIALS_KEY)
  // console.log('localStorage中的记住凭据:', rememberedCredentials)
  if (rememberedCredentials) {
    try {
      const credentials = JSON.parse(rememberedCredentials)
      // console.log('解析后的凭据:', credentials)
      postData.username = credentials.username || ''
      postData.password = credentials.password || ''
      checkedLogin.value = true // 自动勾选记住密码选项
      // console.log('已自动填充账号和密码')
    } catch (e) {
      // console.error('解析记住的账号和密码时出错:', e)
    }
  } else {
    // console.log('localStorage中没有找到记住的凭据')
  }
})

// 监听记住账号和密码选项的变化
watch(checkedLogin, (newVal) => {
  // console.log('记住密码选项变化:', newVal)
  if (!newVal) {
    // 如果取消勾选，清除保存的账号和密码
    localStorage.removeItem(REMEMBER_CREDENTIALS_KEY)
    // console.log('用户取消勾选，已清除保存的账号和密码')
  }
})

const rules = computed(() => ({
  username: [
    { required: true, message: t('home-index.auth.usernameRequired') },
    {
      min: 4,
      validator: (val) => {
        const value = val.trim()
        return value.length >= 4
      },
      message: t('home-index.auth.usernameFormat', {
        min: 4,
        max: 14,
      }),
    },
    {
      max: 14,
      validator: (val) => {
        const value = val.trim()
        return value.length <= 14
      },
      message: t('home-index.auth.usernameFormat', {
        min: 4,
        max: 14,
      }),
    },
  ],
  password: [
    { required: true, message: t('home-index.auth.passwordRequired') },
    {
      min: MIN_LOGIN_PWD,
      validator: (val) => {
        const value = val.trim()
        return value.length >= MIN_LOGIN_PWD
      },
      message: t('home-index.auth.loginPasswordRule', {
        min: MIN_LOGIN_PWD,
        max: MAX_PWD,
      }),
    },
    {
      max: MAX_PWD,
      message: t('home-index.auth.loginPasswordRule', {
        min: MIN_LOGIN_PWD,
        max: MAX_PWD,
      }),
    },
  ],
}))

async function loginHandle(values) {
  // 登录 设备参数
  try {
    const url = new URL(window.location.href)
    const urlParams = url.searchParams
    let inviteCode = urlParams.get('id') || ''
    let channelId = urlParams.get('channel_id') || ''
    let businessId = urlParams.get('business_id') || ''
    if (inviteCode || channelId || businessId) {
      localStorage.setItem('id', inviteCode || '')
      localStorage.setItem('channel_id', channelId || '')
      localStorage.setItem('business_id', businessId || '')
    } else {
      inviteCode = localStorage.getItem('id') || ''
      channelId = localStorage.getItem('channel_id') || ''
      businessId = localStorage.getItem('business_id') || ''
    }
    loading.value = true
    const deviceData = await getDeviceInfo()
    const ttclid = urlParams.get('ttclid') || ''
    const fbclid = urlParams.get('fbclid') || ''
    window.history.replaceState(null, null, url.toString())
    await userStore
      .handleLogin({
        ...postData,
        ...values,
        password: postData.password.trim(),
        ...deviceData,
        id: inviteCode, // 邀请码
        url: window.location.href,
        channel_id: channelId, // 渠道id
        business_id: businessId, // 商家id
        ttclid,
        fbclid,
      })
      .then((res) => {
        // 如果用户选择了记住账号和密码，则保存账号和密码
        if (checkedLogin.value) {
          const credentials = {
            username: postData.username,
            password: postData.password,
          }
          localStorage.setItem(REMEMBER_CREDENTIALS_KEY, JSON.stringify(credentials))
          // console.log('保存账号和密码到localStorage:', credentials)
        } else {
          // 如果没有选择记住账号和密码，确保清除已保存的账号和密码
          localStorage.removeItem(REMEMBER_CREDENTIALS_KEY)
          // console.log('清除localStorage中的账号和密码')
        }
        if (
          router.currentRoute.value &&
          router.currentRoute.value.redirectedFrom &&
          router.currentRoute.value.redirectedFrom.fullPath
        ) {
          router.push({ path: router.currentRoute.value.redirectedFrom.fullPath })
        } else {
          router.push({ name: 'Home', query: { refresh: Date.now().toString() } })
        }
        handleCloseLoginRegisterPopup()
        // const res = await userStore.fetchUserInfo() // console.log('fetchUserInfo', res) // router.push({ name: 'Home' })
      })
      .catch((err) => {
        console.log('登录报错~~~', err)
        // handleOpenErrorPopup()
      })
  } finally {
    loading.value = false
  }
}

const rulesReg = computed(() => {
  return {
    username: [
      { required: true, message: t('home-index.auth.usernameRequired') },
      {
        min: 4,
        validator: (val) => {
          const value = val.trim()
          return value.length >= 4
        },
        message: t('home-index.auth.usernameFormat', {
          min: 4,
          max: 14,
        }),
      },
      {
        max: 14,
        validator: (val) => {
          const value = val.trim()
          return value.length <= 14
        },
        message: t('home-index.auth.usernameFormat', {
          min: 4,
          max: 14,
        }),
      },
    ],
    password: [
      { required: true, message: t('home-index.auth.passwordRequired') },
      {
        min: MIN_PWD,
        validator: (val) => {
          const value = val.trim()
          return value.length >= MIN_PWD
        },
        message: t('home-index.auth.registerPasswordRule', {
          min: MIN_PWD,
          max: MAX_PWD,
        }),
      },
      {
        max: MAX_PWD,
        validator: (val) => {
          const value = val.trim()
          return value.length <= MAX_PWD
        },
        message: t('home-index.auth.registerPasswordRule', {
          min: MIN_PWD,
          max: MAX_PWD,
        }),
      },
    ],
    password_confirm: [
      {
        required: !isPasswordVisible.value,
        message: t('home-index.auth.confirmPasswordRequired'),
      },
      {
        validator: (val) => {
          if (isPasswordVisible.value) {
            return true
          }
          const password = postDataReg.password.trim()
          const confirmPassword = val.trim()
          return confirmPassword === password
        },
        message: t('home-index.auth.passwordMismatch'),
      },
    ],
  }
})
const registerHandle = async () => {
  // const urlParams = new URLSearchParams(window.location.search)
  const url = new URL(window.location.href)
  const urlParams = url.searchParams
  let inviteCode = urlParams.get('id') || ''
  let channelId = urlParams.get('channel_id') || ''
  let businessId = urlParams.get('business_id') || ''
  if (inviteCode || channelId || businessId) {
    localStorage.setItem('id', inviteCode || '')
    localStorage.setItem('channel_id', channelId || '')
    localStorage.setItem('business_id', businessId || '')
  } else {
    inviteCode = localStorage.getItem('id') || ''
    channelId = localStorage.getItem('channel_id') || ''
    businessId = localStorage.getItem('business_id') || ''
  }
  // 此项目没用 协议勾选  if (!checkedReg.value) { showNotify({ type: 'danger', message: 'Verifique primeiro o acordo de utilizador' })  return  }
  try {
    loading.value = true
    const deviceData = await getDeviceInfo()
    // let deviceId = '' if (localStorage.getItem('deviceId')) {  deviceId = localStorage.getItem('deviceId') } else { deviceId = uuidv4().replace(/-/g, '')  localStorage.setItem('deviceId', uuidv4().replace(/-/g, '')) // 后改成store持久化  }
    // 注册 设备参数
    const reModal = {
      username: postDataReg.username,
      password: postDataReg.password.trim(),
      password_confirm: postDataReg.password.trim(), // password_confirm
      phone: postDataReg.username,
      id: inviteCode, // 邀请码
      channel_id: channelId, // 渠道id
      business_id: businessId, // 商家id
      ...deviceData,
      url: window.location.href,
    }
    const ttclid = urlParams.get('ttclid') || ''
    const fbclid = urlParams.get('fbclid') || ''
    reModal.ttclid = ttclid
    reModal.fbclid = fbclid
    urlParams.delete('ttclid')
    urlParams.delete('fbclid')
    window.history.replaceState(null, null, url.toString())
    // console.log('sendShareIds:registerHandle', reModal)
    // console.log('sendShareIds:registerHandle', urlParams)
    const res = await userStore.register(reModal)
    if (res.code == 1) {
      checkedReg.value = false
      handleCloseLoginRegisterPopup()
      if (
        router.currentRoute.value &&
        router.currentRoute.value.redirectedFrom &&
        router.currentRoute.value.redirectedFrom.fullPath
      ) {
        router.push({ path: router.currentRoute.value.redirectedFrom.fullPath })
      } else {
        router.push({ name: 'Home', query: { refresh: Date.now().toString() } }) // router.push({ name: 'Home' })
      }
      // 清空表单数据
      postDataReg.password = ''
      postDataReg.username = ''
      postDataReg.phone = ''
      postDataReg.password_confirm = ''
    } else {
      // showNotify({ type: 'error', message: res.message || '注册失败' })
    }
  } finally {
    loading.value = false
  }
}
const registerFailed = (errorInfo) => {
  console.log('注册验证失败:', errorInfo)
  // console.log('注册验证失败:', errorInfo)
}

const goToTelegram = () => {
  // 打开新窗口 的 Telegram 带上对方的Telegram 号 可行？
  window.open('https://t.me/bjgame_official')
}

const isComposing = ref(false)

const handleUsernameKeydown = (event) => {
  // 允许的按键：字母、数字、退格、删除、Tab、Escape、Home、End、方向键
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
  ]

  // 允许的字符正则表达式（字母和数字）
  const allowedCharPattern = /[a-zA-Z0-9]/

  // 如果正在使用输入法，不阻止输入
  if (isComposing.value) {
    return
  }

  // 如果是允许的特殊按键，直接允许
  if (allowedKeys.includes(event.key)) {
    return
  }

  // 如果是Ctrl、Alt、Meta组合键，允许（以便用户可以复制粘贴等操作）
  if (event.ctrlKey || event.altKey || event.metaKey) {
    return
  }

  // 如果字符不符合要求，阻止输入
  if (!allowedCharPattern.test(event.key)) {
    event.preventDefault()
  }
}

const handleCompositionStart = () => {
  isComposing.value = true
}

const handleCompositionEnd = (event) => {
  isComposing.value = false
  // 在输入法结束时，过滤掉非法字符
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postDataReg.username = filteredValue
}

const handleUsernameInput = (event) => {
  // 如果正在使用输入法，不处理input事件
  if (isComposing.value) {
    return
  }

  // 作为后备保护，再次过滤输入内容
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postDataReg.username = filteredValue
}

const handleLoginUsernameKeydown = (event) => {
  // 允许的按键：字母、数字、退格、删除、Tab、Escape、Home、End、方向键
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
  ]

  // 允许的字符正则表达式（字母和数字）
  const allowedCharPattern = /[a-zA-Z0-9]/

  // 如果正在使用输入法，不阻止输入
  if (isComposing.value) {
    return
  }

  // 如果是允许的特殊按键，直接允许
  if (allowedKeys.includes(event.key)) {
    return
  }

  // 如果是Ctrl、Alt、Meta组合键，允许（以便用户可以复制粘贴等操作）
  if (event.ctrlKey || event.altKey || event.metaKey) {
    return
  }

  // 如果字符不符合要求，阻止输入
  if (!allowedCharPattern.test(event.key)) {
    event.preventDefault()
  }
}

const handleLoginUsernameInput = (event) => {
  // 如果正在使用输入法，不处理input事件
  if (isComposing.value) {
    return
  }

  // 作为后备保护，再次过滤输入内容
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postData.username = filteredValue
}

const handleLoginCompositionStart = () => {
  isComposing.value = true
}

const handleLoginCompositionEnd = (event) => {
  isComposing.value = false
  // 在输入法结束时，过滤掉非法字符
  const value = event.target.value
  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '')
  postData.username = filteredValue
}

/**
 * 忘记密码
 */
const forgetPasswordVisible = ref(false)
const handleForgetPwd = () => {
  handleCloseLoginRegisterPopup()
  forgetPasswordVisible.value = true
}

const closeForgetPwd = () => {
  forgetPasswordVisible.value = false
  handleOpenLoginRegisterPopup()
}

// 跳转到客户端
const toCliente = () => {
  const list = pathsStore.getPaths() || []
  const targetItem = list.find((item) => item.type == 2)
  // console.log('targetItem ----- ', JSON.parse(localStorage.getItem('toPaths')).currentPaths)
  if (targetItem && targetItem.url) {
    window.open(targetItem.url)
  } else {
    console.warn('未找到ID对应的链接:', id)
  }
}

const emit = defineEmits(['close'])

defineExpose({ openPopupRegLogin })
</script>

<style scoped lang="less">
.dragon-img-box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .dragon-img {
    position: absolute;
    left: 50%;
    bottom: calc(70% - 85px);
    transform: translateX(-50%);
    width: 180px;
    height: 253px;
    z-index: 10;
  }
  .dragon-img-shan {
    position: absolute;
    left: 0;
    top: 0;
    width: 375px;
    height: 375px;
    z-index: 9;
    animation: dragon-img-shan-rotate 6s linear infinite;
  }

  .dragon-img-shan.animation-paused {
    animation-play-state: paused;
  }

  @keyframes dragon-img-shan-rotate {
    0% {
      transform: translateX(0) rotate(0deg);
    }
    100% {
      transform: translateX(0) rotate(360deg);
    }
  }
}
.login-reg-popup-container {
  position: absolute;
  bottom: 0;
  z-index: 10;
  padding: 16px;
  width: 100vw;
  height: 70%;
  background: var(--login-popup-bg);
  backdrop-filter: blur(10px);
  box-shadow: var(--login-popup-inset-shadow);
  border-radius: 12px 12px 0 0;

  .header-container {
    text-align: center;
    margin-bottom: 20px;
    line-height: 1;

    .title,
    .subtitle {
      display: block;
      color: var(--text-primary);
      font-weight: 700;
    }

    .title {
      font-size: 16px;
    }

    .subtitle {
      font-size: 24px;

      i {
        background: var(--login-popup-subtitle-text-gradient);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: var(--login-popup-subtitle-text-fallback);
      }
    }
  }

  :deep(.van-tabs) {
    --van-tabs-nav-background: var(--bg-tertiary);
    --van-tabs-text-color: var(--tabs-text);
    --van-tabs-active-text-color: var(--tabs-active-text);
    --van-tab-text-color: var(--tabs-text);
    --van-tab-active-text-color: var(--tabs-active-text);
    --van-tabs-bottom-bar-height: 0;

    .van-tabs__wrap {
      padding: 5px;
      background: var(--bg-tertiary);
      border: 1px solid rgb(from var(--border-secondary) r g b / 0.5);
      border-radius: 8px;

      .van-tab {
        color: var(--tabs-text);
        border-radius: 4px;
        font-weight: 700;
        background: var(--bg-tertiary);

        &.van-tab--active {
          color: var(--tabs-active-text);
          background: var(--tabs-active-bg);
        }
      }
    }
  }

  :deep(.van-form) {
    padding: 16px 0;

    .van-field + .van-field {
      margin-top: 10px;
    }
    .van-field {
      padding: 10px 10px 6px;
      background: var(--color-40000);
      border: none;
      border-radius: 8px;
      overflow: visible;
      --van-field-label-width: 0;
      --van-field-icon-size: 16px;
      --van-field-input-text-color: var(--text-primary);
      --van-field-placeholder-text-color: var(--text-tertiary);
      --van-field-label-color: var(--special-danger-10000);
      --van-field-clear-icon-color: var(--icon-secondary);

      .van-field__left-icon,
      .van-field__right-icon {
        .icon {
          width: 28px;
          height: 28px;
        }
      }

      .van-field__left-icon {
        margin-right: 10px;

        .label-icon-box {
          // padding-right: 10px;
          // border-right: 1px solid rgb(from var(--border-secondary) r g b / 0.5);

          .label {
            margin-left: 5px;
            font-size: 14px;
            color: var(--text-primary);
          }
        }
      }

      .van-cell__value {
        .van-field__body {
          height: 32px;
        }

        &.van-field__value {
          overflow: visible;
        }

        .van-field__error-message {
          color: var(--special-danger-10000);
          word-wrap: normal;
          line-height: 1;
        }
      }
    }

    .checkbox-box {
      margin: 10px 0 24px;
      --van-checkbox-size: 14px;
      --van-checkbox-border-color: var(--login-popup-checkbox-border);
      --van-checkbox-checked-icon-color: var(--login-popup-checkbox-icon-color);

      .van-checkbox__icon {
        &.van-checkbox__icon--checked {
          .van-badge__wrapper::before {
            opacity: 1;
          }
        }

        .van-badge__wrapper {
          position: relative;
          background: transparent;
          border: 2px solid var(--color-10000);

          &::before {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 8px;
            height: 8px;
            content: '';
            background: var(--color-10000);
            border-radius: 100%;
            opacity: 0;
          }
        }
      }

      .van-checkbox__label {
        font-size: 12px;
        font-weight: 700;
        color: var(--text-tertiary);
        line-height: 1;
      }
    }

    .__button_primary {
      &.submit {
        margin: 0 16px;
        width: calc(100% - 32px);
      }
    }
  }

  .footer-container {
    color: var(--text-tertiary);
    font-size: 14px;
  }
}
</style>
